var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ios-bug-fixed",rawName:"v-ios-bug-fixed"}],ref:"typer",staticClass:"message-input",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"input":_vm.changeText,"focus":_vm.inputFocus,"blur":function($event){_vm.isLocked = false}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e6c175e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/flexibleTextInput.vue
// module id = null
// module chunks = 